export const stats = {
  general: {
    block: {
      main: 'Calls',
      acd: 'ACD',
      asr: 'ASR'
    },

    filter: {
      group_by: {
        title: 'Group by',
        values: {
          day: 'Day',
          month: 'Month',
          country: 'Country'
        }
      },

      type: {
        title: 'Type',
        values: {
          outgoing: 'Outgoing',
          incoming: 'Incoming'
        }
      },

      source: {
        title: 'Data source'
      },

      destination: {
        title: 'Destination'
      }
    },

    field: {
      group: 'Group',
      total: 'Total',
      asr: 'ASR',
      acd: 'ACD',
      duration: 'Duration',
      cost: 'Cost'
    }
  },

  detailed: {
    field: {
      country: 'country',
      source: 'Data Source (A-Number)',
      destination: 'Direction (B-number)',
      duration: 'Duration',
      cost: 'Cost',
      date: 'Date',
      call_type: 'Call type',
      audio: 'Audio'
    }
  }
};
